import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-155">
      <div className="max-w-4xl mx-auto text-center" data-id="element-156">
        {/* Logo */}
        <div className="text-[#FFD700] text-3xl font-black tracking-widest mb-8" data-id="element-157">
          🎹 PROFEPACK™
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-158">
          El próximo domingo podés seguir buscando partituras en YouTube.
        </h2>
        <p className="text-[#FFD700] text-2xl sm:text-3xl font-black mb-10" data-id="element-159">
          O podés tener todo resuelto desde hoy.
        </p>

        {/* Cost Table */}
        <div className="bg-[#1a1400] border border-[#FFD700]/30 rounded-2xl overflow-hidden mb-12 max-w-2xl mx-auto text-left" data-id="element-160">
          <div className="p-4 bg-[#0d0a00] border-b border-[#FFD700]/30 text-center font-bold text-white" data-id="element-161">
            ¿Cuánto cuesta realmente NO tenerlo?
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-162">
            <div className="p-4 text-gray-400 text-sm" data-id="element-163">
              3 horas de planificación por semana × 40 semanas = 120 horas de tu
              vida por año
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#FFD700]/5 sm:border-l border-gray-800" data-id="element-164">
              Planificación de 10 minutos por semana — el resto es enseñar
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-165">
            <div className="p-4 text-gray-400 text-sm" data-id="element-166">
              Clases sin sistema de evaluación → alumnos que no ven progreso y
              se van
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#FFD700]/5 sm:border-l border-gray-800" data-id="element-167">
              Evaluaciones trimestrales con rúbricas → alumnos que ven su avance
              y renuevan
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-168">
            <div className="p-4 text-gray-400 text-sm" data-id="element-169">
              Material improvisado sin progresión → alumnos que se aburren y
              desertan
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#FFD700]/5 sm:border-l border-gray-800" data-id="element-170">
              6 tomos con progresión probada → alumnos que avanzan y recomiendan
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-171">
            <div className="p-4 text-gray-400 text-sm" data-id="element-172">
              Sin sistema de cobros ni contratos → perseguir pagos y perder
              dinero
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#FFD700]/5 sm:border-l border-gray-800" data-id="element-173">
              Contratos claros + mes adelantado → ingresos predecibles sin
              conversaciones incómodas
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-174">
            <div className="p-4 text-gray-400 text-sm" data-id="element-175">
              Sin banco de scripts ni seguimiento → faltas constantes que te
              hacen perder dinero
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#FFD700]/5 sm:border-l border-gray-800" data-id="element-176">
              Sistema VIP WhatsApp → asistencia alta y alumnos comprometidos
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-177">
            <div className="p-4 text-gray-400 text-sm" data-id="element-178">
              Clases improvisadas que no enganchan → alumnos que no te
              recomiendan
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#FFD700]/5 sm:border-l border-gray-800" data-id="element-179">
              Sistema completo visible → padres que te recomiendan a otros
              padres
            </div>
          </div>
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-180">
          <p className="text-white font-bold mb-4" data-id="element-181">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-182" />
        </div>
        <p className="text-gray-300 text-sm mb-12" data-id="element-183">
          Después sube{' '}
          <span className="text-[#FF0000] font-bold" data-id="element-184">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* 2 mini pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-2xl mx-auto" data-id="element-185">
          <div className="bg-[#0a0a0a] border border-[#FFD700]/30 rounded-xl p-6 text-center flex flex-col" data-id="element-186">
            <div className="text-2xl mb-2" data-id="element-187">📘</div>
            <h3 className="text-white font-black mb-1" data-id="element-188">MEGAPACK PIANO LISTO</h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-189">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-190">
              <p className="text-[#FFD700] text-2xl font-black mb-4" data-id="element-191">
                $19.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48155974566144:1" className="btn-green-pulse block bg-[#FFD700] text-black font-black py-4 rounded-lg hover:bg-[#FFE44D] transition-colors text-sm" data-id="element-192">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          <div className="bg-[#0d0a00] border-2 border-[#FFD700] rounded-xl p-6 text-center shadow-[0_0_30px_rgba(255,215,0,0.2)] flex flex-col" data-id="element-193">
            <div className="text-2xl mb-2" data-id="element-194">🏆</div>
            <h3 className="text-[#FFD700] font-black mb-1" data-id="element-195">
              MEGAPACK + ACADEMIA EXPLOSIVA ⭐
            </h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-196">
              6 Tomos + 6 Bonos + Academia Explosiva™
            </p>
            <div className="mt-auto" data-id="element-197">
              <p className="text-[#FFD700] text-3xl font-black mb-4" data-id="element-198">
                $27.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48156054978816:1" className="btn-green-pulse block bg-[#FFD700] text-black font-black py-4 rounded-lg hover:bg-[#FFE44D] transition-colors text-sm" data-id="element-199">
                → QUIERO EL MEGAPACK + ACADEMIA EXPLOSIVA
              </a>
            </div>
          </div>
        </div>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-200">
          <span data-id="element-201">🔒 Pago 100% seguro</span>
          <span data-id="element-202">⚡ Acceso en 5 minutos</span>
          <span data-id="element-203">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-204">
            💳 Mercado Pago | Tarjeta de crédito | Transferencia bancaria
          </span>
        </div>
      </div>
    </section>;
}